// packages/frontend/src/app/pages/Landing.tsx
import React from 'react';
import Header from '../sections/Header';
import Payment from '../sections/Payment';
import MediaLibrary from '../sections/MediaLibrary';
import Footer from '../sections/Footer';

export default function Landing() {
  return (
    <div className="landing">
      <Header />
      <Payment />
      <MediaLibrary />
      <Footer />
    </div>
  );
}
